// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_EaPbN {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal_Td7g0 {
  background-color: var(--white-background);
  border-radius: 8px;
  padding: 20px;
  width: 320px;
  text-align: center;
  box-shadow: 0 4px 15px var(--_00000033-shadow);
  color: var(--black-color);
}

.iconContainer_gVaQi {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.icon_CEt4M {
  width: 60px;
  height: 60px;
  background-color: var(--_16c098-color);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.checkmark_m9qsk {
  color: var(--white-background);
  font-size: 32px;
  font-weight: bold;
}

.title_cHnxW {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
}

.message_bqLaE {
  font-size: 14px;
  margin-bottom: 20px;
  color: #cfcfcf;
}

.dashboardButton_HkyHi {
  background-color: var(--_16c098-color);
  color: var(--white-background);
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.3s;
}

.dashboardButton_HkyHi:hover {
  background-color: #13a880;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/AccountSettings/StripeComponents/PaymentSuccess.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background-color: var(--white-background);\n  border-radius: 8px;\n  padding: 20px;\n  width: 320px;\n  text-align: center;\n  box-shadow: 0 4px 15px var(--_00000033-shadow);\n  color: var(--black-color);\n}\n\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.icon {\n  width: 60px;\n  height: 60px;\n  background-color: var(--_16c098-color);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.checkmark {\n  color: var(--white-background);\n  font-size: 32px;\n  font-weight: bold;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 10px 0;\n}\n\n.message {\n  font-size: 14px;\n  margin-bottom: 20px;\n  color: #cfcfcf;\n}\n\n.dashboardButton {\n  background-color: var(--_16c098-color);\n  color: var(--white-background);\n  border: none;\n  border-radius: 6px;\n  padding: 10px 16px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n  transition: background-color 0.3s;\n}\n\n.dashboardButton:hover {\n  background-color: #13a880;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_EaPbN`,
	"modal": `modal_Td7g0`,
	"iconContainer": `iconContainer_gVaQi`,
	"icon": `icon_CEt4M`,
	"checkmark": `checkmark_m9qsk`,
	"title": `title_cHnxW`,
	"message": `message_bqLaE`,
	"dashboardButton": `dashboardButton_HkyHi`
};
export default ___CSS_LOADER_EXPORT___;
